import React, { useCallback, useState } from 'react';

import styles from './Account.module.css';
import Button from '../Button/Button';
import AccountPopup from './AccountPopup';
import TextInput from '../TextInput/TextInput';

const Account = ({
    field,
    changed,
    validateOldPassword,
    validateDomainName,
    testMetadata,
    header,
    passwordConfirmation,
    disabled,
    marginTop = true,
    validatePassword = false
}) => {
    const [openModal, setOpenModal] = useState(false);

    const togglePopup = useCallback(() => {
        setOpenModal(!openModal);
    }, [openModal, setOpenModal]);

    const onSave = (user, pass, oldPass) => {
        changed(field.id, { user, pass, oldPass });
        setOpenModal(false);
    };

    const onClear = () => {
        const currentValue = field.value;
        const clearedValue = { user: '', pass: '', oldPass: '' };

        const hasDataToClear = currentValue.user || currentValue.pass || currentValue.oldPass;

        if (hasDataToClear) {
            changed(field.id, clearedValue);
        }
    };

    const accountField = {
        ...field,
        value: field.value.user
    };

    return (
        <div className={marginTop ? styles.account : null}>
            <TextInput field={accountField} disabled changed={changed}>
                <Button disabled={disabled} onClick={togglePopup}>
                    Update
                </Button>
            </TextInput>
            {openModal && (
                <AccountPopup
                    userValue={field.value.user}
                    validateOldPassword={validateOldPassword}
                    validateDomainName={validateDomainName}
                    testMetadata={testMetadata}
                    onSave={onSave}
                    onCancel={togglePopup}
                    onClear={onClear}
                    header={header}
                    passwordConfirmation={passwordConfirmation}
                    validatePassword={validatePassword}
                />
            )}
        </div>
    );
};

export default React.memo(Account);
